<template>
  <div class="uploadWarp">
    <van-row >
       <div class="uploadImg">
         <img :src="imgUrl"  />
       </div>
       <p class="uploadText">恭喜您！提交成功！</p>
    </van-row>
    <van-row>
       <van-button class="back" @click="backHome">返回首页</van-button>
        </van-row>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    // 返回首页
    backHome() {
      this.$router.push({ path: '/' })
    }
  },
  created() {
    this.imgUrl = require("./../assets/succeicon.png");
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.uploadWarp {
  width: 100%;
  height:365px;
  // position:relative;
  z-index: -10;
  background-image: url("./../assets/successiconi.png");
  background-repeat: no-repeat;
  background-position:center;
  background-size: 100% 100%;
  // margin-top: 298px;
  // text-align: center;
  // width: 750px;
  // height: 1206px;
}
// .bgImg {
//   width:100%;
//   height: 100%;
//   background-size: 50% 50%;
//   background:url("./../assets/success.png");
//   background-repeat: no-repeat;
// }
.uploadImg {
  width: 90px;
  height: 90px;
  margin:0 auto;
  padding-top:90px;
}
.uploadImg img {
   width:100%;
   height:100%;
}
.uploadText {
  font-size:16px;
  font-family:PingFang SC;
  font-weight:500;
  color: #9D3909;
  line-height:13px;
  text-align:center;
  position: absolute;
  top:43%;
  left:32%;
}
.back {
  border: 1px solid rgba(157,57,9,1);
  border-radius:5px;
  font-size:14px;
  font-family:PingFang SC;
  font-weight:500;
  color:rgba(157,57,9,1);
  line-height:13px;
  position:absolute;
  left:38%;
  top: 50%;
}
</style>
